/*
 * @Description: Description
 * @Author: ranli
 * @Date: 2026-04-10 14:06:24
 * @LastEditTime: 2026-04-16 14:51:20
 * @LastEditors: ranli
 */
// 传参通道
const MODE = process.env.NODE_ENV || 'dev'
// 默认参数
const defaultParams = {
  prod: {
    appId: 'FS101',
    mobile: '9876543227',
    thirdUserId: 'FS101_7',
    sign: '3bfddddda3075be2',
    uid: 'f7d33753804449dcba54528215223f4a'
  },
  stage: {},
  dev: {
    appId: 'FS101',
    mobile: '9876543227',
    thirdUserId: 'FS101_7',
    sign: '3bfddddda3075be2',
    uid: 'f7d33753804449dcba54528215223f4a'
  },
}

export default defaultParams[MODE]
